import React, { useCallback } from 'react';
import { getSyncingStatus, syncAllConnections, syncConnection, } from 'actions/connections';
import Modal from 'utils/packages/Modal';
import Text from 'design-system/Text';
import { Spacer } from 'design-system';
import { benefits } from 'features/premium/benefits';
import { isPremiumTier, Tier } from 'features/premium/entities';
import { useIsTierUnlockedForSpace } from 'features/premium/hooks/useIsTierUnlockedForSpace';
import { selectUserTier } from 'features/premium/selectors/tier';
import { muteErrorAndResult, useFetchOld } from 'hooks/useFetch';
import { useSuggestNotification } from 'hooks/useSuggestNotification';
import { Keyboard, StyleSheet, View } from 'react-native';
import { useAppDispatch, useAppSelector, useAppStore } from 'store/hooks';
import { selectIsGBUser } from 'reducers/selectors';
import { RenderUnlockIcon } from 'features/premium/components/PremiumFeatureMicroModalContent';
import { selectShouldShowMicroModal } from 'features/premium/selectors';
import useV3MicroModal from 'features/premium/hooks/useV3MicroModal';
import ForceSyncUpgradeModal from './ForceSyncUpgradeModal';
const useForceSync = () => {
    const store = useAppStore();
    const dispatch = useAppDispatch();
    const [, , isFetching, fetch] = useFetchOld(muteErrorAndResult);
    const isUnlockedForSpace = useIsTierUnlockedForSpace(benefits.forceSync.minTier);
    const isGBUser = useAppSelector(selectIsGBUser);
    // Ab test
    const showMicroModal = useAppSelector(selectShouldShowMicroModal);
    const v3MicroModal = useV3MicroModal();
    const title = useCallback((userTier) => {
        const titleString = userTier === Tier.plus
            ? 'Emma updates 4 times a day'
            : 'Emma updates once a day';
        if (showMicroModal) {
            return (<View style={styles.container}>
            <Spacer h={40}/>
            <RenderUnlockIcon />
            <Spacer h={16}/>
            <Text Text-20 centered>
              Unlock On-demand Sync
            </Text>
          </View>);
        }
        return titleString;
    }, [showMicroModal]);
    const suggestNotification = useSuggestNotification('force_sync');
    const forceSync = useCallback(async (connectionId) => {
        const state = store.getState();
        const userTier = selectUserTier(state);
        if (isUnlockedForSpace || !isGBUser) {
            const result = connectionId == null
                ? await fetch(syncAllConnections())
                : await fetch(syncConnection(connectionId, false));
            if (result?.isSyncingManual) {
                dispatch(getSyncingStatus());
                await suggestNotification('Syncing your data…', 'Connecting your accounts may take a little while. Want us to send a push notification when everything is ready?');
            }
        }
        else {
            Keyboard.dismiss();
            if (showMicroModal === 'v3') {
                v3MicroModal(isPremiumTier(benefits.forceSync.minTier)
                    ? benefits.forceSync.minTier
                    : undefined, 'forceSync');
            }
            else {
                Modal.show(<ForceSyncUpgradeModal />, {
                    title: title(userTier),
                });
            }
        }
    }, [
        isGBUser,
        isUnlockedForSpace,
        showMicroModal,
        title,
        v3MicroModal,
        suggestNotification,
    ]);
    return [isFetching, forceSync];
};
const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});
export default useForceSync;
